import AScene from "../../library/ExtendedObjects/AScene"
import gameData from "../../gameData.js";
import MakeACake from "./MakeACake.js";
import muteButton from "../../library/muteButton";
import ABCyaPhaser, { Audio } from "@abcya/abcya_phaser";
import LocalizationSoundAssetKeys from "../../Localization-SoundAssetKeys";
import FontKeys from "../../FontKeys.js";

export default class MakeACakePlacer extends AScene
{
    static get KEY() { return 'MakeACakePlacer'; }
    create()
        {
            this.Cake;
            this.CakeMask;
            this.Plate;
            this.Active;
            this.TabList = [];
            this.ToolBackground;
            this.BackLog = [];
            this.IsPaused = false;
            this.ObjectCount = 0;
            this.SlideIncrement = 210;
            this.DrawOn = [];
            this.CurrentIcing = "null";
            this.NeedNewRender = true;
            this.MoveThis = "null";
            this.MouseUpCheck = false;
            this.PauseBackDrop;

            this.IsDrawing = true;
            this.PaintSize = 2;
            this.PaintTint = 0xffffff;
            this.PrevNumber = 1;
            this.PaintDraw = [22.5,18.5,14.5,12,8.5];
            this.PrevSize;
            this.LogDraw;
            this.DepthList = {
                DrawTool:0,
                Fondant:0,
                PlacedItems:0,
                TabList:0,
                Render:0,
                Snapshot:0,
                OverImage:0,
                PauseBackDrop:0
            };

            var i = 0;

            for (let x in this.DepthList)
            {
                this.DepthList[x] = i;
                i++;
            }

            //this.PaintDraw[0] = this.addImage(this.mid.x, this.mid.y, "Decorations/Paint/Draw1.png");
            //this.PaintDraw[1] = this.addImage(this.mid.x, this.mid.y, "Decorations/Paint/Draw2.png");
            //this.PaintDraw[2] = this.addImage(this.mid.x, this.mid.y, "Decorations/Paint/Draw3.png");
            //this.PaintDraw[3] = this.addImage(this.mid.x, this.mid.y, "Decorations/Paint/Draw4.png");
            //this.PaintDraw[4] = this.addImage(this.mid.x, this.mid.y, "Decorations/Paint/Draw5.png"); 

            this.PaintGroup = this.add.group();
            this.IcingGroup = this.add.group();
            this.PatternGroup = this.add.group();
            this.DecorGroup = this.add.group();
            this.FlowerGroup = this.add.group();
            this.CandleGroup = this.add.group();
            this.LettersGroup = this.add.group();
            this.NumbersGroup = this.add.group();

            this.CakeGroup = this.add.group();
            this.MaskAndPaint = this.add.group();
            this.CandlesToSend = this.add.group();
            this.FireGroup = this.add.group();

            var x;
            var OriginAdjustmentX;
            var OriginAdjustmentY;
            var OldPlacement = {x: 0, y:0};
            var FireRef;

            this.BackGround = this.addImage(this.mid.x, this.mid.y, "Background.png");
            this.Plate = this.addImage(668.5, this.mid.y+this.mid.y - 149-75, "Plate.png");
            this.ToolBackground = this.addImage(0, 745, "Drawer_Large.png");
            this.TabList[0] = this.addImage(-30, 30 + (103*1), "Btn_Icing.png");
            this.TabList[1] = this.addImage(-30, 30 + (103*2), "Decorations/Tab_Icing.png");
            this.TabList[2] = this.addImage(-31, 29 + (103*3), "Decorations/Tab_Pattern.png");
            this.TabList[3] = this.addImage(-30, 28 + (103*4), "Decorations/Tab_Decor.png");
            this.TabList[4] = this.addImage(-30, 26 + (103*5), "Decorations/Tab_Flower.png");
            this.TabList[5] = this.addImage(-30, 25 + (103*6), "Decorations/Tab_Candle.png");
            this.TabList[6] = this.addImage(-30, 24 + (103*7), "Btn_Numbers.png");

            this.DoneButton = this.add.container(654, this.scale.height-40, [
              this.addImage(0,0, "NewAsset/Btn_Done.png").setInteractive({useHandCursor: true}).on('pointerdown',()=>{this.DoneAction();}),
              ABCyaPhaser.Text.addText(24,-4, 36, 0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("make_a_cake_screens.done_button"), this).setShadow(-4, 1,"#f58a1f")
            ]);

            this.PauseBackDrop = this.add.rectangle(0,0,1024,768,'#333840',.3);
            this.PauseBackDrop.setOrigin(0,0);
            this.PauseBackDrop.setDepth(this.DepthList.PauseBackDrop);
            this.PauseBackDrop.setVisible(false);

            this.addTween(this.DoneButton,700,{y: {start: this.DoneButton.y + 400, to:this.DoneButton.y}},Phaser.Math.Easing.Quadratic.InOut);
            this.AddHomeButton();
            muteButton(this);
            this.AddBackButton();
            this.AddStartOverButton();

            this.Cake = this.addImage(this.Plate.x, this.Plate.y + 40, "MCake.png");
            this.Cake.setOrigin(.5,1);

            this.Cake.setTint(gameData.CakeTint);
            this.CakeMask = this.Cake.createBitmapMask();

            this.CakeGroup.add(this.Plate);
            this.CakeGroup.add(this.Cake);

            for(x in this.TabList) //Set Tab Location
            {
                this.TabList[x].setOrigin(0,1);
                this.TabList[x].name = x;
                this.TabList[x].on('pointerdown',function(){
                    this.scene.TabClickHandler(this.name);
                });
                this.TabList[x].setDepth(this.DepthList.TabList);
            }

            this.ToolBackground.setOrigin(0,1);

            this.Active = this.TabList[0];

            //Tween In
            if (this.SoundOnButton.visible === false)
            {
                this.ButtonRollIn(this.SoundOffButton,700,Phaser.Math.Easing.Linear,true);
            }
            else 
            {
                this.ButtonRollIn(this.SoundOnButton,700,Phaser.Math.Easing.Linear,true);
            }
            this.ButtonRollIn(this.BackButton,700,Phaser.Math.Easing.Linear,true);
            this.ButtonRollIn(this.HomeButton,700,Phaser.Math.Easing.Linear,true);
            this.ButtonRollIn(this.StartOverButton,700,Phaser.Math.Easing.Linear,true);
            this.TabMenuTweenIn();
            this.SlidePlateInTween();
            this.SetUpTween();
            //this.FallingInTween()
            //

            //this.PaintEntry();

            //input listeners for this scene
            //this.input.on('pointermove')

            this.input.on('dragstart', (pointer,item)=>
            {
                OldPlacement.x = item.x;
                OldPlacement.y = item.y;
                OriginAdjustmentX = item.x - pointer.x;
                OriginAdjustmentY = item.y - pointer.y;
                if (item.getData('AssetType') === "Icing")
                {
                    item.setDepth(this.TabList.PlacedItems);
                }
                if (item.getData('AssetType') === "Candle")
                {
                    item.getData('Fire').setVisible(false);
                }
            });

            this.input.on('drag',(pointer, GameObject)=>
            {
                if (this.IsPaused === false && this.IsDrawing === false)
                {
                    GameObject.x = pointer.x + OriginAdjustmentX;
                    GameObject.y = pointer.y + OriginAdjustmentY;
                }
            });

            this.input.on('dragend',(pointer, GameObject)=>
            {
                if (OldPlacement.x != GameObject.x && OldPlacement.y != GameObject.y)
                {
                    if((GameObject.x - (GameObject.width/2)) < 320 || (GameObject.y + (GameObject.height/2))> 1024 || this.OverButtonCheck(GameObject) === true)
                    {
                        if (GameObject.getData('AssetType') != "Icing")
                        {
                            this.MoveBackLogClear(GameObject);
                        }
                        else
                        {
                            this.IcingRemoveFromBack(GameObject);
                        }
                    }
                    else
                    {
                        switch (GameObject.getData('AssetType'))
                        {
                            case "Icing":
                                GameObject.setDepth(this.DepthList.Fondant);
                                this.IcingCenter(GameObject,"Move");
                                break;
                            case "Pattern":
                                if(this.BoundsOverlap(GameObject,this.Cake))
                                {
                                    //GameObject.setMask(this.CakeMask);
                                    this.CreateBackLogEntry("Move",GameObject,OldPlacement,"Pattern");
                                }
                                else
                                {
                                    this.MoveBackLogClear(GameObject);
                                    //GameObject.destroy();
                                }
                                break;
                            case "Candle":
                                if (this.ShapeContainsObjectBottomCenter(this.ellipse,GameObject))
                                {
                                    this.CreateBackLogEntry("Move",GameObject,OldPlacement,"Candle");
                                    FireRef = GameObject.getData('Fire');
                                        FireRef.x = GameObject.x;
                                        FireRef.y = GameObject.y - ((GameObject.height)*.8);
                                        FireRef.setVisible(true);
                                }
                                else
                                {
                                    GameObject.getData('Fire').destroy;
                                    this.MoveBackLogClear(GameObject);
                                }
                                break;
                            default:
                                this.CreateBackLogEntry("Move",GameObject,OldPlacement,GameObject.getData('AssetType'));
                                break;
                        }
                    }
                }
            });

            this.input.on('pointerup',()=>
            {
                if (this.MouseUpCheck === true)
                {
                    this.IsPaused = false;
                    this.MouseUpCheck = false;
                }
            });


            //this.input.on('drag')

            //End scene wide listeners

            //Candle Constraint Shape and mask shape
            var Graphic = this.add.graphics({ lineStyle: {color: 0x00aaaa } });
            var Shape = this.make.graphics();
            var EllipseBottom;
            var RectCenter;
            Shape.fillStyle(0xffffff);
            Shape.beginPath();
            //Shape.fillRect(this.mid.x,this.mid.y,400,600);
            this.ellipse = new Phaser.Geom.Ellipse(this.Cake.x, this.Cake.y - 330, 484, 122);
            EllipseBottom = new Phaser.Geom.Ellipse(this.Cake.x, this.Cake.y-60, 484, 122);
            RectCenter = new Phaser.Geom.Rectangle(427, 255, 483, 268);
            Shape.fillEllipseShape(this.ellipse);

            //Graphic.fillEllipseShape(EllipseBottom);
            //Graphic.fillEllipseShape(this.ellipse);
            //Graphic.fillRectShape(RectCenter);
            Shape.fillEllipseShape(EllipseBottom);
            Shape.fillRectShape(RectCenter);
            this.CakeMask = Shape.createGeometryMask();
            //this.CakeGroup.add(this.CakeMask);
        } // End Bracket for create()

    TabClickHandler(TabNumber)//Should tween the tabs
        {
            if (this.Active.name != TabNumber && this.IsPaused === false)
            {
                if (this.Active.type === "Image")
                {
                    this.Active.x = -30;
                    switch(this.Active.name)
                    {
                    case "0":
                        this.ToolBackgroundTweenOut(this.PaintGroup,this.Active.name);
                        //this.StandardExit(this.PaintGroup);
                        this.IsDrawing = false;
                        break;
                    case "1":
                        //this.StandardExit(this.IcingGroup);
                        this.ToolBackgroundTweenOut(this.IcingGroup,this.Active.name);
                        break;
                    case "2":
                        this.ToolBackgroundTweenOut(this.PatternGroup,this.Active.name);
                        //this.StandardExit(this.PatternGroup);
                        break;
                    case "3":
                        this.ToolBackgroundTweenOut(this.DecorGroup,this.Active.name);
                        //this.StandardExit(this.DecorGroup);
                        break;
                    case "4":
                        this.ToolBackgroundTweenOut(this.FlowerGroup,this.Active.name);
                        //this.StandardExit(this.FlowerGroup);
                        break;
                    case "5":
                        this.ToolBackgroundTweenOut(this.CandleGroup,this.Active.name);
                        //this.StandardExit(this.CandleGroup);
                        break;
                    case "6":
                        this.ToolBackgroundTweenOut(this.NumbersGroup,this.Active.name);
                        break;
                    default:
                        break;
                    }
                }
                this.Active = this.TabList[TabNumber];
                switch(this.Active.name)
                {
                    case "0":
                        this.PaintEntry();
                        this.ToolBackgroundTweenIn(this.PaintGroup,this.Active.name);
                        break;
                    case "1":
                        this.IcingEntry();
                        this.ToolBackgroundTweenIn(this.IcingGroup,this.Active.name);
                        break;
                    case "2":
                        this.PatternEntry();
                        this.ToolBackgroundTweenIn(this.PatternGroup,this.Active.name);
                        break;
                    case "3":
                        this.DecorEntry();
                        this.ToolBackgroundTweenIn(this.DecorGroup,this.Active.name);
                        break;
                    case "4":
                        this.FlowerEntry();
                        this.ToolBackgroundTweenIn(this.FlowerGroup,this.Active.name);
                        break;
                    case "5":
                        this.CandleEntry();
                        this.ToolBackgroundTweenIn(this.CandleGroup,this.Active.name);
                        break;
                    case "6":
                        this.NumbersEntry();
                        this.ToolBackgroundTweenIn(this.NumbersGroup,this.Active.name);
                        break;
                    default:
                        break;
                }
                this.TabList[TabNumber].x = 0;
            }
        }

    DoneButttonLeaveCheck()
        {
            if (this.Active.type === "Image")
            {
                //this.Active.x = -30;
                switch(this.Active.name)
                {
                case "0":
                    this.ToolBackgroundTweenOut(this.PaintGroup,this.Active.name,300);
                    //this.StandardExit(this.PaintGroup);
                    this.IsDrawing = false;
                    break;
                case "1":
                    //this.StandardExit(this.IcingGroup);
                    this.ToolBackgroundTweenOut(this.IcingGroup,this.Active.name,300);
                    break;
                case "2":
                    this.ToolBackgroundTweenOut(this.PatternGroup,this.Active.name,300);
                    //this.StandardExit(this.PatternGroup);
                    break;
                case "3":
                    this.ToolBackgroundTweenOut(this.DecorGroup,this.Active.name,300);
                    //this.StandardExit(this.DecorGroup);
                    break;
                case "4":
                    this.ToolBackgroundTweenOut(this.FlowerGroup,this.Active.name,300);
                    //this.StandardExit(this.FlowerGroup);
                    break;
                case "5":
                    this.ToolBackgroundTweenOut(this.CandleGroup,this.Active.name,300);
                    //this.StandardExit(this.CandleGroup);
                    break;
                case "6":
                    this.ToolBackgroundTweenOut(this.NumbersGroup,this.Active.name,300);
                    break;
                default:
                    this.ToolBackgroundTweenOut(this.PaintGroup,this.Active.name,300);
                    this.IsDrawing = false;
                    break;
                }
            }
        }

    //Tab Entry Exit section

    PaintEntry()
        {
            var TintButton = [];
            var SizeList = [];
            var SizeInstructions;
            var i;
            var points;
            var circle = this.add.circle(-100,-100,17,this.PaintTint);
            var DrawLog;

            var PaintMethod = 0;

            this.IsDrawing = true;
            this.PaintSize = 2;
            this.PaintTint = 0xffffff;
            this.PrevNumber = 1;
              
            SizeInstructions = ABCyaPhaser.Text.addText(278 -this.SlideIncrement,194+51, 36, 0xfceeff, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("make_a_cake_screens.size_label"), this, true).setShadow(-2, 2, "#b983c6").setResolution(2);
            ABCyaPhaser.Text.resizeFontToFitWidth(SizeInstructions, 60, null, 36);
            this.PaintGroup.add(SizeInstructions);

            for (i=0; i<10;i++)
            {
                TintButton[i] = this.addImage(158 -this.SlideIncrement, 115  + ((i)* 60), "Cake Color/Clr_"+(i+1)+".png");
                TintButton[i].number = i;
                TintButton[i].setScale(.64,.64);
                if (i == 0)TintButton[i].setScale(.5,.5);
                TintButton[i].on('pointerdown',function()
                {
                    if ((this.number + 1) != this.PrevNumber && this.scene.IsPaused === false)
                    {
                        this.setScale(.5,.5);
                        this.scene.SetBrushTint(this.number);
                    }
                });
                TintButton[i].setInteractive();
                this.PaintGroup.add(TintButton[i]);
            }

            for (i=10; i<20;i++)
            {
                TintButton[i] = this.addImage(218 -this.SlideIncrement, 115 + ((i-10)* 60), "Cake Color/Clr_"+(i+1)+".png");
                TintButton[i].number = i;
                TintButton[i].setScale(.64,.64);
                
                TintButton[i].on('pointerdown',function()
                {
                    if ((this.number + 1) != this.PrevNumber && this.scene.IsPaused === false)
                    {
                        this.setScale(.5,.5);
                        this.scene.SetBrushTint(this.number);
                    }
                });
                TintButton[i].setInteractive();
                this.PaintGroup.add(TintButton[i]);
            }

            for(i=0;i<5;i++)
            {
                SizeList[i] = this.addImage(278 -this.SlideIncrement, 287 + ((i)* 60), "Decorations/Paint/Size_"+(5-i)+".png");
                if(i === 2)
                {
                    SizeList[i].setTint(0x424242);
                    this.PaintSize = i;
                    this.PrevSize = SizeList[i];
                }
                SizeList[i].number = i
                SizeList[i].setInteractive();
                this.PaintGroup.add(SizeList[i]);
                SizeList[i].on('pointerdown',function()
                {
                    if(this.scene.IsPaused === false) this.scene.SetSize(this.number,this);
                });
            }

            this.input.on('pointerdown',(pointer,localX,localY,event)=> {
                
                if (pointer.isDown && this.IsDrawing === true && pointer.x > 442 && pointer.x < 924 && pointer.y < 659 && pointer.y > 269 && this.IsPaused === false && PaintMethod === 0)
                {
                    this.SoundCheck("place_item");
                }
            });


            this.input.on('pointermove',(pointer,localX,localY,event)=> {
        
                ////console.log(this.Cake.getLeftCenter());

                if (pointer.isDown && this.IsDrawing === true && pointer.x > 427 && pointer.x < (this.Cake.x+(this.Cake.width/2)) && pointer.y < (this.Cake.y) && pointer.y > (this.Cake.y - this.Cake.height) && this.IsPaused === false && PaintMethod === 0)
                {
                    this.AddRenderTextureCheck();
                    circle.fillColor = (this.PaintTint);
                    circle.radius = this.PaintDraw[this.PaintSize];
                    //this.PaintDraw[this.PaintSize].setAlpha(.01);
                    points = pointer.getInterpolatedPosition(15);

                    //points.forEach(()=>
                    //{
                        //this.LogDraw = true;
                        //this.BackLog[this.ObjectCount] = this.DrawOn[this.DrawOn.length-1].draw(circle, pointer.x - 315, pointer.y);
                        //this.BackLog[this.ObjectCount].name = "draw";

                        //DrawLog = this.DrawOn[this.DrawOn.length-1].draw(circle, pointer.x -this.Cake.getLeftCenter().x, pointer.y-this.Cake.getTopCenter().y);

                        
                    //});

                    for(let x in points)
                    {
                        this.LogDraw = true;
                        DrawLog = this.DrawOn[this.DrawOn.length-1].draw(circle, points[x].x -this.Cake.getLeftCenter().x, points[x].y-this.Cake.getTopCenter().y);
                    }
                }
           
            }, this);

            this.input.on('pointerup',()=>
            {
                if(this.LogDraw)
                {
                    this.NeedNewRender = true;
                    this.AddRenderTextureCheck();
                    this.CreateDrawBackLog(this.DrawOn[this.DrawOn.length-1],DrawLog);
                    this.LogDraw = false;
                }
            });
        }

    IcingEntry()
        {
            var i;
            var NumberOfItems = 6;
            var Sections = 716/NumberOfItems;
            var IcingArray = [];
            var DisplayLog;
            for (i=0;i<NumberOfItems;i++)
            {
                DisplayLog = "case ";
                IcingArray[i] = this.addImage(220-this.SlideIncrement,30+((Sections/2)+2)+(i*Sections),"Decorations/Icing/Icing_"+(i+1)+".png");
                DisplayLog += IcingArray[i].frame.name + ": \nGameObject.x = " + (IcingArray[i].x + this.SlideIncrement) + ";\nGameObject.y = " + IcingArray[i].y + ";\nbreak;";
                ////console.log(DisplayLog);
                IcingArray[i].setScale(.30,.25);
                ////console.log(IcingArray[i].scale.ENVELOPE);
                IcingArray[i].setInteractive();
                IcingArray[i].on('pointerdown',function(pointer)
                {
                    this.scene.CreateCopyOfAsset(this,pointer,"Icing");
                });
                this.IcingGroup.add(IcingArray[i]);
            }
        }
          
    PatternEntry()
        {
            var i;
            var NumberOfItems = 8;
            var Sections = 716/NumberOfItems;
            var PatternArray = [];
            for (i=0;i<NumberOfItems;i++)
            {
                PatternArray[i] = this.addImage(220-this.SlideIncrement,30+((Sections/2)+2)+(i*Sections),"Decorations/Patterns/Pttrn_"+(i+1)+".png");
                PatternArray[i].setScale(.75);
                PatternArray[i].setInteractive();
                PatternArray[i].on('pointerdown',function(pointer)
                {
                    this.scene.CreateCopyOfAsset(this,pointer,"Pattern");
                });
                this.PatternGroup.add(PatternArray[i]);
            }
        }

    DecorEntry()
        {
            var i;
            var NumberOfItems = 11;
            var DecorArray = [];
            var DecorLocation =
            [
                [188,78],
                [165,185],
                [197,399],
                [268,615],
                [272,530],
                [234,251],
                [262,409],
                [266,145],
                [206,691],
                [162,609],
                [171,542]
            ];
            for (i=0;i<NumberOfItems;i++)
            {
                DecorArray[i] = this.addImage(DecorLocation[i][0]-this.SlideIncrement,DecorLocation[i][1],"Decorations/Decor/Dcr_"+(i+1)+".png");
                DecorArray[i].setScale(.75);
                DecorArray[i].setInteractive();
                DecorArray[i].on('pointerdown',function(pointer)
                {
                    this.scene.CreateCopyOfAsset(this,pointer,"Decoration");
                });
                this.DecorGroup.add(DecorArray[i]);
            }
        }

    FlowerEntry()
        {
            var i;
            var FlowerArray = [];
            var NumberOfItems = 10;
            var Sections = 716/NumberOfItems;

            for (i=0; i<10;i++)
            {
                FlowerArray[i] = this.addImage(179-this.SlideIncrement,26+((Sections/2)+2)+(i*Sections), "Decorations/Flowers/Flwr_"+(i+1)+".png");
                FlowerArray[i].setScale(.5);
                FlowerArray[i].setInteractive();
                FlowerArray[i].on('pointerdown',function(pointer)
                {
                    this.scene.CreateCopyOfAsset(this,pointer,"Flower");
                });
                this.FlowerGroup.add(FlowerArray[i]);
            }

            for (i=10; i<20;i++)
            {
                FlowerArray[i] = this.addImage(271-this.SlideIncrement,26+(((Sections/2)+2)+((i-10)*Sections)), "Decorations/Flowers/Flwr_"+(i+1)+".png");
                FlowerArray[i].setScale(.5);
                FlowerArray[i].setInteractive();
                FlowerArray[i].setInteractive();
                FlowerArray[i].on('pointerdown',function(pointer)
                {
                    this.scene.CreateCopyOfAsset(this,pointer,"Flower");
                });
                this.FlowerGroup.add(FlowerArray[i]);
            }
        }

    CandleEntry()
        {
            var i;
            var CandleArray = [];
            var FireArray = [];
            var NumberOfItems = 3;
            var Sections = 716/NumberOfItems;
            var Rectangle = [];

            for (i=0; i<3;i++)
            {
                CandleArray[i] = this.addImage(179-this.SlideIncrement,26+((Sections/2)+2)+(i*Sections), "Decorations/Candles/Cndl_"+(i+1)+".png");
                FireArray[i] = this.addImage(179-this.SlideIncrement,CandleArray[i].y - ((CandleArray[i].height*.6)/2), "Decorations/Candles/Cndl_Fire_"+(i+1)+".png");
                FireArray[i].setScale(.60);
                CandleArray[i].setScale(.60);

                CandleArray[i].setInteractive();

                CandleArray[i].input.hitArea.setTo(-20,-FireArray[i].height, CandleArray[i].width + 50, CandleArray[i].height + FireArray[i].height);

                CandleArray[i].on('pointerdown',function(pointer)
                {
                    this.scene.CreateCopyOfAsset(this,pointer,"Candle");
                });
                this.CandleGroup.add(CandleArray[i]);
                this.CandleGroup.add(FireArray[i]);

                if (i != 0)
                {
                    FireArray[i].setOrigin(.5,1);
                    //FireArray[i].y -= (((FireArray[i].height * .60)/2)+5);
                    this.CandleFireIdleTween( FireArray[i]);
                }
                else
                {
                    //FireArray[i].x += 5;
                    FireArray[0].setOrigin(.45,.49);
                    this.addRepeatingEvent(100,()=>
                    {
                        //console.log("Speed is 180");
                        FireArray[0].setRotation(Math.random());
                    },-1);
                }
                
            }

            for (i=3; i<6;i++)
            {
                CandleArray[i] = this.addImage(271-this.SlideIncrement,26+((Sections/2)+2)+((i-3)*Sections), "Decorations/Candles/Cndl_"+(i+1)+".png");
                FireArray[i] = this.addImage(271-this.SlideIncrement,CandleArray[i].y - ((CandleArray[i].height*.6)/2), "Decorations/Candles/Cndl_Fire_"+(i+1)+".png");
                FireArray[i].setScale(.60);
                CandleArray[i].setScale(.60);
                //FireArray[i].y -= (((FireArray[i].height * .60)/2)+5);

                CandleArray[i].setInteractive();

                if (i != 5)
                {
                    CandleArray[i].input.hitArea.setTo(-20,-FireArray[i].height, CandleArray[i].width + 50, CandleArray[i].height + FireArray[i].height);
                }
                else
                {
                    CandleArray[i].input.hitArea.setTo(-20,-FireArray[i].height, CandleArray[i].width + 50, CandleArray[i].height + FireArray[i].height);
                }

                CandleArray[i].on('pointerdown',function(pointer)
                {
                    this.scene.CreateCopyOfAsset(this,pointer,"Candle");
                });
                this.CandleGroup.add(CandleArray[i]);
                this.CandleGroup.add(FireArray[i]);
                FireArray[i].setOrigin(.5,1);
                this.CandleFireIdleTween( FireArray[i]);
            }
        }

    StandardExit(PassedGroup)
        {
            PassedGroup.clear(true,true);
        }

    NumbersEntry()
        {   
        
            var i;
            var DisplayNumList = [1,3,5,7,9,2,4,6,8,0];
            var NumbersArray = [];
            var NumberOfItems = 5;
            var Sections = 716/NumberOfItems;

            for (i=0; i<5;i++)
            {
                NumbersArray[i] = this.addImage(175-this.SlideIncrement,29+((Sections/2)+2)+(i*Sections)-4, ""+(DisplayNumList[i])+".png");
                //NumbersArray[i].setScale(.);
                NumbersArray[i].setInteractive();
                NumbersArray[i].on('pointerdown',function(pointer)
                {
                    this.scene.CreateCopyOfAsset(this,pointer,"Number");
                });
                this.NumbersGroup.add(NumbersArray[i]);
            }
            
            for (i=5; i<10;i++)
            {
                NumbersArray[i] = this.addImage(267-this.SlideIncrement,29+(((Sections/2)+2)+((i-5)*Sections)-4), ""+(DisplayNumList[i])+".png");
                //NumbersArray[i].setScale(.5);
                NumbersArray[i].setInteractive();
                NumbersArray[i].on('pointerdown',function(pointer)
                {
                    this.scene.CreateCopyOfAsset(this,pointer,"Number");
                });
                this.NumbersGroup.add(NumbersArray[i]);
            }
        }

    LettersEntry()
        {
            var x;
            var LettersStock = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
            var LettersArray = [];
            for (x = 0; x<13;x++)
            {
                LettersArray[x] = this.add.text(287+(x*35),695,LettersStock[x],
                {
                    fontFamily: 'snigletregular',
                        fontSize: 32, 
                        color:'#FFFFFF',
                        origin: .5,
                        shadow: {
                            offsetX: -1,
                            offsetY: .5,
                            stroke: true,
                            fill: true
                        }
                });
                LettersArray[x].on('pointerdown',function(pointer)
                {
                    if(this.scene.IsPaused === false) this.scene.AddLetterOrNumber(this.text,pointer);
                });
                LettersArray[x].setInteractive();
                this.LettersGroup.add(LettersArray[x]);
            }
    
            for (x = 13; x<26;x++)
            {
    
                LettersArray[x] = this.add.text(287+(((x-13)*35)),730,LettersStock[x],
                {
                    fontFamily: 'snigletregular',
                        fontSize: 32, 
                        origin: .5,
                        color:'#FFFFFF',
                        shadow: {
                            offsetX: -1,
                            offsetY: .5,
                            stroke: true,
                            fill: true
                        }
                });
                LettersArray[x].on('pointerdown',function(pointer)
                {
                    if(this.scene.IsPaused === false) this.scene.AddLetterOrNumber(this.text,pointer);
                });
                LettersArray[x].setInteractive();
                this.LettersGroup.add(LettersArray[x]);
            }
        }

    //End Tab Entry Exit Section

    //TabFunctionScreen
    CreateCopyOfAsset(Asset,Pointer,AssetType)
        {
            var Temp;
            var Event;
            if(this.IsPaused === false)
            {
                Temp = this.addImage(Pointer.x,Pointer.y,Asset.frame.name);
                Temp.setData({TrayX: Asset.x,TrayY: Asset.y, TrayScale: Asset.scale});
                Temp.setInteractive();
                this.scene.MoveThis = Temp;

                switch (AssetType)
                {
                    case "Icing":
                        Temp.setScale(.9);
                        Temp.setDepth(this.DepthList.PlacedItems);
                        switch(Temp.frame.name)
                        {
                            case "Decorations/Icing/Icing_1.png":
                                Temp.setScale(.88);
                                break;
                            case "Decorations/Icing/Icing_5.png":
                                Temp.setScale(.95);
                                break;
                            case "Decorations/Icing/Icing_6.png":
                                Temp.setScale(.95);
                                break;
                            default:
                                break;
                        }
                        break;

                    case "Candle":
                        Temp.setOrigin(.5,.8);
                        Temp.setDepth(this.DepthList.PlacedItems);
                        break;

                    case "Pattern":
                        //if (Temp.frame.name === "Decorations/Patterns/Pttrn_7.png") this.CakeMask.dirty = true;
                        Temp.setDepth(this.DepthList.PlacedItems);
                        break;
                
                    default:
                        Temp.setDepth(this.DepthList.PlacedItems);
                        break;
                }

                this.input.setDraggable(Temp);
                Temp.on('pointermove',function()
                {
                    ////console.log("move");
                    this.scene.MoveThis = Temp;
                });

                Temp.on('pointerup',function()
                {
                    this.scene.SoundCheck("place_item");
                    Temp.removeListener('pointermove');
                    this.scene.MoveThis = "null";
                    if((Temp.x - (Temp.width/2)) < 320 || (Temp.y + (Temp.height/2))> 1024 || this.scene.OverButtonCheck(Temp) === true)
                    {
                        if (AssetType === "Icing")
                        {
                            this.scene.IcingCenter(Temp);
                            Temp.removeListener('pointerup');
                            Temp.setDepth(this.scene.DepthList.Fondant);
                        }
                        else
                        {
                            this.scene.TweenBackToTray(Temp);
                        }
                    }
                    else
                    {
                        Temp.removeListener('pointerup');
                        switch(AssetType)
                        {
                            case "Icing":
                                this.scene.IcingCenter(Temp);
                                this.scene.CakeGroup.add(Temp);
                                Temp.setDepth(this.scene.DepthList.Fondant);
                                break;
                            case "Candle":
                                this.scene.CandlePlaceCheck(Temp);
                                this.scene.CakeGroup.add(Temp);
                                break;
                            case "Pattern":
                                this.scene.PatternMask(Temp);
                                this.scene.CakeGroup.add(Temp);
                                //this.scene.MaskAndPaint.add(Temp);
                                break;
                            default:
                                this.scene.CreateBackLogEntry("Place",Temp,"null",AssetType);
                                this.scene.CakeGroup.add(Temp);
                                break;
                        }
                    }
                });
            }
        }

    IcingCenter(Icing,Operation)
        {
            if (Operation != "Move")
            {
                if (this.CurrentIcing === "null")
                {
                    this.CurrentIcing = Icing;
                    this.CreateBackLogEntry("Place",Icing,"null","Icing");
                }
                else
                {
                    this.CreateBackLogEntry("Replace",Icing,this.CurrentIcing,"Icing");
                    ////console.log("detroying prev");
                    this.CurrentIcing.destroy();
                    this.CurrentIcing = Icing;
                }
            }

            this.PlaceIcing(Icing);
            //Icing.disableInteractive();
        }

    PlaceIcing(Icing)
        {
            Icing.x = this.Cake.x;
            switch(Icing.frame.name)
            {
                case "Decorations/Icing/Icing_1.png":
                    Icing.y = this.Cake.y - 293;
                    break;
                case "Decorations/Icing/Icing_3.png":
                    Icing.y = this.Cake.y - 319;
                    break;
                case "Decorations/Icing/Icing_4.png":
                    Icing.y = this.Cake.y - 319;
                    break;
                case "Decorations/Icing/Icing_5.png":
                    Icing.y = this.Cake.y - 304;
                    break;
                case "Decorations/Icing/Icing_6.png":
                    Icing.y = this.Cake.y - 329;
                    break;
                default:
                    Icing.y = this.Cake.y - 315;
                    break;
            }
        }

    CandlePlaceCheck(Candle)
        {
            if (!this.ShapeContainsObjectBottomCenter(this.ellipse,Candle))
            {
                this.TweenBackToTray(Candle);
            }
            else
            {
                this.CreateBackLogEntry("Place",Candle,"null","Candle");
                this.AddFireToCandle(Candle);
            }
        }

    AddFireToCandle(Candle)
        {
            var CandleNameSplit;
            var Fire;

            CandleNameSplit = Candle.frame.name.split("_");
            //console.log(CandleNameSplit[0]+"_Fire_"+CandleNameSplit[1]);

            Fire = this.addImage(Candle.x,Candle.y - ((Candle.height)*.8),CandleNameSplit[0]+"_Fire_"+CandleNameSplit[1]);
            if (Fire.frame.name === "Decorations/Candles/Cndl_Fire_1.png")
            {
                Fire.setOrigin(.45,.49);
                Fire.setDepth(this.DepthList.PlacedItems);
                this.addRepeatingEvent(100,()=>
                {
                    Fire.setRotation(Math.random());
                },-1);
            }
            else
            {
                Fire.setOrigin(.5,1);
                Fire.setDepth(this.DepthList.PlacedItems);
                //Fire.setScale(.60);
                this.CandleFireIdleTween(Fire);
            }
            //console.log(Candle.getTopCenter());
            this.CandlesToSend.add(Candle);
            this.FireGroup.add(Fire);
            this.CandleTop = Candle.getTopCenter();
            Candle.setData({Fire: Fire});
        }

    PatternMask(Pattern)
        {
            if (this.BoundsOverlap(this.Cake,Pattern))
            {
                Pattern.setMask(this.CakeMask);
                this.CreateBackLogEntry("Place",Pattern,"null","Pattern");
            }
            else
            {
                Pattern.clearMask();
                this.TweenBackToTray(Pattern);
            }
        }

    ShapeContainsObjectBottomCenter(Shape,GameObject)
        {
            var BottomCenterPoint = GameObject.getBottomCenter();
            ////console.log(BottomCenterPoint);
            return Shape.contains(BottomCenterPoint.x,BottomCenterPoint.y);
        }

    BoundsOverlap(Object1,Object2)
        {
            var Bounds1 = Object1.getBounds();
            var Bounds2 = Object2.getBounds();

            return Phaser.Geom.Rectangle.Overlaps(Bounds1,Bounds2);
        }
        

    SetBrushTint(TintNum)
        {
            var TintList =
                    [
                        0xffffff,
                        0x424242,
                        0x7c3f09,
                        0xca6c15,
                        0xfcb984,
                        0x5e9afc,
                        0x88d159,
                        0x5ce0be,
                        0x68f2ee,
                        0x62d5ef,
                        0x5f40d3,
                        0xa554f7,
                        0xdd67f9,
                        0xff5cae,
                        0xff97d0,
                        0xc32139,
                        0xef4f3b,
                        0xfedc4b,
                        0xf9af1e,
                        0xff8c3d,
                    ];
            ////console.log(TintList[TintNum]);
            this.PaintTint = TintList[TintNum];
            this.PaintGroup.getChildren().forEach((child)=>
            {
                if ((child.frame.name) === ("Cake Color/Clr_"+this.PrevNumber+".png"))
                {
                    child.setScale(.64,.64);
                }
            });
            this.PrevNumber = TintNum + 1;
        }

    SetSize(Number,Current)
        {
            if (this.PaintSize != Number)
            {
                Current.setTint(0x424242);
                this.PrevSize.setTint(0xffffff);
                this.PrevSize = Current;
                this.PaintSize = Number;
            }
        }

    AddLetterOrNumber(text,pointer)
        {
            var Temp;

            if(this.Active.name == 0)
            {
                this.IsDrawing = false;
            }
            
            
            Temp = this.add.text(pointer.x ,pointer.y,text,            
                {
                fontFamily: 'snigletregular',
                    fontSize: 56, 
                    color:'#FFFFFF',
                    shadow: {
                        offsetX: -1,
                        offsetY: .5,
                        stroke: true,
                        fill: true
                    }
                });

                Temp.setOrigin(.5,.5);

                Temp.setInteractive();
                this.input.setDraggable(Temp);
                Temp.on('pointermove',function(pointer)
                {
                    Temp.x = pointer.x;
                    Temp.y = pointer.y;
                });

                Temp.on('pointerup',function()
                {
                    if(this.scene.Active.name == 0)
                        {
                            this.scene.IsDrawing = true;
                        }
                    Temp.removeAllListeners();
                    if((Temp.x - (Temp.width/2)) < 320 || (Temp.y + (Temp.height/2))> 1024)
                    {
                        Temp.destroy();
                    }
                    else
                    {
                        if(this.scene.Active.name == 0)
                        {
                            //this.AddRenderTextureCheck();
                        }
                    }
                });
                this.BackLog[this.ObjectCount] = Temp;
                this.ObjectCount++;
            
        }
        

    //End TabFunctionScreen

    //Bottom of screen Buttons

    AddBackButton()
        {
            var x;
            var BackRef;
            var PrevIcing;
            var DrawArray = [];
            var Fire;
            //var Length =this.BackLog.length;
            this.BackButton = this.addButton(this.mid.x+this.mid.x - 50,110, "Btn_Undo.png", null, ()=>
            {
                //this.BackButton.disableInteractive();
                /*
                for (x = 0; x < this.BackLog.length;x++)
                {
                    if (this.BackLog[x].Type === "RenderTexture")
                    {
                        Occur1 = x;
                        if ((Occur1-Occur2) === 1)
                        {
                            //this.BackLog[Occur1].destroy();
                            this.BackLog.splice(x,1);
                            Occur2 = Occur1;
                            x = 0;
                        }
                        else
                        {
                            Occur2 = Occur1;
                        }
                    }
                    this.ObjectCount = this.BackLog.length;
                    if (x ==  (this.BackLog.length - 1))
                    {
                        //this.BackButton.setInteractive();
                    }
                }
                
                if (this.ObjectCount != 0)
                {
                    if (this.BackLog[this.ObjectCount-1].Type === "RenderTexture" && this.ObjectCount != 1 && this.Active.name == 0)
                    {
                        this.BackLog[this.ObjectCount-1].destroy();
                        this.BackLog.pop();
                        this.ObjectCount--;
                    }
                    this.BackLog[this.ObjectCount-1].destroy();
                    this.BackLog.pop();
                    this.ObjectCount--;
                    if(this.Active.name == 0)
                    {
                        this.AddRenderTextureCheck();
                    }

                }
                //console.log(this.BackLog);
                */
               
               this.SoundCheck("undo");
               if (this.BackLog.length > 0)
               {
                    //Back log: type:(place, move..),Id,PrevAssetType,PrevId,Previous,Ref(to the image),AssetType(of the Image)
                    ////console.log(this.BackLog[(this.BackLog.length - 1)].Type);
                    //console.log(this.BackLog);
                    switch (this.BackLog[this.BackLog.length - 1].Type)
                    {
                            case "Move":
                                this.BackLog[this.BackLog.length - 1].Ref.x = this.BackLog[this.BackLog.length - 1].Previous.x;
                                this.BackLog[this.BackLog.length - 1].Ref.y = this.BackLog[this.BackLog.length - 1].Previous.y;
                                if (this.BackLog[this.BackLog.length - 1].AssetType === "Candle")
                                {
                                    Fire = this.BackLog[this.BackLog.length - 1].Ref.getData('Fire');
                                    Fire.x = this.BackLog[this.BackLog.length - 1].Ref.x;
                                    Fire.y = this.BackLog[this.BackLog.length - 1].Ref.y - ((this.BackLog[this.BackLog.length - 1].Ref.height)*.8);
                                }
                                this.BackLog.pop();
                                break;
                            case "Place":
                                //console.log(this.BackLog[this.BackLog.length - 1]);

                                if (this.BackLog[this.BackLog.length - 1].AssetType === "Candle")
                                {
                                    this.BackLog[this.BackLog.length - 1].Ref.getData('Fire').destroy();
                                }
                            
                                this.BackLog[this.BackLog.length - 1].Ref.destroy();
                                this.BackLog.pop();
                                break;
                            case "Replace":
                                //Removes new frosting, makes a new frosting that was the old one, and resets it to the old back entry
                                BackRef = this.BackLog[this.BackLog.length - 1];
                                if (this.CurrentIcing != "null")
                                {
                                    this.CurrentIcing.destroy();
                                }
                                PrevIcing = this.addImage(BackRef.Previous.x,BackRef.Previous.y,BackRef.Previous.frame.name);
                                PrevIcing.setDepth(this.DepthList.Fondant);
                                PrevIcing.scale = BackRef.Previous.scale;
                                this.PlaceIcing(PrevIcing);
                                for(x=0; x < this.BackLog.length; x++)
                                {
                                    if (this.BackLog[x].Id === BackRef.PrevID)
                                    {
                                        ////console.log(this.BackLog[x].Id);
                                        PrevIcing.setData('BackID',BackRef.PrevID);
                                        this.CurrentIcing = PrevIcing;
                                        this.BackLog[x].Ref = PrevIcing;
                                        x = this.BackLog.length;
                                    }
                                }
                                PrevIcing.setData('AssetType',"Icing");
                                this.BackLog.pop();
                                PrevIcing.setInteractive();
                                this.input.setDraggable(PrevIcing);
                                //this.IcingCenter(PrevIcing);
                                break;
                            case "Draw":
                                BackRef = this.BackLog[this.BackLog.length - 1];
                                BackRef.Drawing.destroy();
                                this.BackLog.pop();
                                break;
                            default:
                                break;
                    }
                }
            });

            this.BackButton.PlaySound = false;
            this.BackButton.setOrigin(.5, .5);
        }
    
    AddStartOverButton()
        {
            var x;
            var MenuBack;
            var YesBtn;
            var NoBtn;
            var Quit;

            this.StartOverButton = this.addButton(this.mid.x+this.mid.x - 50,180, "Btn_Start_Over.png", null, ()=>
            {
                this.SoundCheck("button_menu_click");
                Quit = this.playSound(LocalizationSoundAssetKeys._are_you_sure_start_over, 1, false, true, Audio.LOCALIZATION_AUDIO_SPRITE);
                this.HomeButton.setEnabled(false);
                this.StartOverButton.setEnabled(false);
                this.BackButton.setEnabled(false);

                this.PauseBackDrop.setVisible(true);

                this.BackButton.tint = 0xffffff
                this.HomeButton.tint = 0xffffff
                this.IsPaused = true;

                //this.scene.pause();
                //this.scene.launch("PauseMenu");

                let menuBg = this.addImage(this.mid.x + 156,this.mid.y,"NewAsset/Quit_Popup.png");
                MenuBack = ABCyaPhaser.Text.addText(522+ 156, 314,60, 0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("confirm_popup.start_over_text"), this).setShadow(-4, 1,"#f58a1f").setWordWrapWidth(550).setPadding(4,4);

                YesBtn = this.addButton(this.mid.x - 148.75+ 156,this.mid.y,"Yes.png");
                let yesBtnTxt = ABCyaPhaser.Text.addText(365+ 156, 442,48,  0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("confirm_popup.yes_button"), this).setShadow(-4, 1,"#f58a1f").setPadding(4,4)
                NoBtn = this.addButton(this.mid.x + 148.75+ 156,this.mid.y,"No.png");
                let noBtnTxt = ABCyaPhaser.Text.addText(664+ 156, 441,48,  0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("confirm_popup.no_button"), this).setShadow(-4, 1,"#f58a1f")

                this.PauseBackDrop.setVisible(true);
                
                this.HomeBtnGroup.addMultiple([YesBtn,NoBtn,MenuBack, menuBg, yesBtnTxt, noBtnTxt]);

                for(x in this.HomeBtnGroup.children.entries)
                { 
                    this.HomeBtnGroup.children.entries[x].setDepth(this.DepthList.PauseBackDrop);
                }

                YesBtn.on('pointerdown',()=>
                {
                        YesBtn.setEnabled(false);
                        NoBtn.setEnabled(false);
                        //this.sound.stopAll();
                        this.scene.start("MakeACake");
                });

                NoBtn.on('pointerdown',()=>
                {
                        YesBtn.setEnabled(false);
                        NoBtn.setEnabled(false);
                        ////console.log("pressed no");
                        ////console.log(this.HomeBtnGroup);
                        this.PauseBackDrop.setVisible(false);
                        this.DestroyMenu(YesBtn,NoBtn,MenuBack,menuBg, yesBtnTxt, noBtnTxt);
                        Quit.stop();
                        this.PausedToPaintCheck();
                });
            });
            this.StartOverButton.PlaySound = false;
            this.StartOverButton.setOrigin(.5, .5);
        }

    //AddHomeButton()
    //    {   
    //        var MenuBack;
    //        var HomeBack;
    //        var YesBtn;
    //        var NoBtn;
    //        var SaveBtn;
    //        var PrintBtn;
    //        var HomeBtn;
    //        var CancelBtn
    //        this.HomeBtnGroup = this.add.group();
    //        var ClearGroup = this.add.group();
//
    //        this.MenuButton = this.addButton(this.mid.x+this.mid.x - 50,50, "Btn_Menu.png", null, ()=>{
    //            this.MenuButton.setEnabled(false);
    //            this.IsPaused = true;
//
    //            //this.scene.pause();
    //            //this.scene.launch("PauseMenu");
//
    //            MenuBack = this.addImage(this.mid.x,this.mid.y,"Menu.png");
//
    //            SaveBtn = this.addImage(this.mid.x - 83.5,this.mid.y + 20,"Save.png");
    //            PrintBtn = this.addImage(this.mid.x + 83.5,this.mid.y + 20,"Print.png");
    //            HomeBtn = this.addImage(this.mid.x - 262, 484,"Btn_Home.png");
    //            CancelBtn = this.addImage(this.mid.x + 262, 484,"x.png");
//
    //            SaveBtn.setScale(.87);
    //            PrintBtn.setScale(.87);
    //            CancelBtn.setScale(.57);
//
    //            SaveBtn.setInteractive();
    //            PrintBtn.setInteractive();
    //            HomeBtn.setInteractive();
    //            CancelBtn.setInteractive();
//
    //            ClearGroup.addMultiple([SaveBtn,PrintBtn,HomeBtn,CancelBtn,MenuBack]);
    //            
    //            //SaveBtn.setOrigin(.5,.5);
    //            //PrintBtn.setOrigin(.5,.5);
    //            //HomeBtn.setOrigin(.5,1);
    //            //CancelBtn.setOrigin(.5,1);
//
    //            //YesBtn = this.addButton(this.mid.x - 200,this.mid.y,"Yes.png");
    //            //NoBtn = this.addButton(this.mid.x + 200,this.mid.y,"No.png");
    //            HomeBtn.on('pointerdown',()=>
    //            {
    //                HomeBack = this.addImage(this.mid.x,this.mid.y,"Home.png");
//
    //                YesBtn = this.addButton(this.mid.x - 200,this.mid.y,"Yes.png");
    //                NoBtn = this.addButton(this.mid.x + 200,this.mid.y,"No.png");
//
    //                this.HomeBtnGroup.addMultiple([YesBtn,NoBtn,HomeBack]);
//
    //                YesBtn.on('pointerdown',()=>
    //                {
    //                        YesBtn.setEnabled(false);
    //                        NoBtn.setEnabled(false);
    //                        this.sound.stopAll();
    //                        this.scene.start("Intro");
    //                });
//
    //                NoBtn.on('pointerdown',()=>
    //                {
    //                        YesBtn.setEnabled(false);
    //                        NoBtn.setEnabled(false);
    //                        this.DestroyMenu(YesBtn,NoBtn,HomeBack);
    //                });
    //            });
//
    //            
    //            CancelBtn.on('pointerdown',()=>
    //            {
    //                this.ClearGroupPass(ClearGroup);
    //            });
    //        });
    //        this.MenuButton.setOrigin(.5,.5);
//
    //        }

    AddHomeButton()
    {   
        var x;
        var MenuBack;
        var YesBtn;
        var NoBtn;
        this.HomeBtnGroup = this.add.group();
        var Quit;

        this.HomeButton = this.addButton(this.mid.x+this.mid.x - 50,40, "NewAsset/Btn_Home.png", null, ()=>{
            this.SoundCheck("button_menu_click");
            Quit = this.playSound(LocalizationSoundAssetKeys._are_you_sure_you_want_to_quit, 1, false, true, Audio.LOCALIZATION_AUDIO_SPRITE);
            this.HomeButton.setEnabled(false);
            this.StartOverButton.setEnabled(false);
            this.BackButton.setEnabled(false);

            this.PauseBackDrop.setVisible(true);

            this.StartOverButton.tint = 0xffffff;
            this.BackButton.tint = 0xffffff;
            this.IsPaused = true;

            //this.scene.pause();
            //this.scene.launch("PauseMenu");

            let menuBg = this.addImage(this.mid.x + 156,this.mid.y,"NewAsset/Quit_Popup.png");
            MenuBack = ABCyaPhaser.Text.addText(522+ 156, 314,60, 0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("confirm_popup.quit_text"), this).setShadow(-4, 1,"#f58a1f").setWordWrapWidth(550).setPadding(4,4);

            YesBtn = this.addButton(this.mid.x - 148.75+ 156,this.mid.y,"Yes.png");
            let yesBtnTxt = ABCyaPhaser.Text.addText(365+ 156, 442,48,  0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("confirm_popup.yes_button"), this).setShadow(-4, 1,"#f58a1f").setPadding(4,4)
            NoBtn = this.addButton(this.mid.x + 148.75+ 156,this.mid.y,"No.png");
            let noBtnTxt = ABCyaPhaser.Text.addText(664+ 156, 441,48,  0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("confirm_popup.no_button"), this).setShadow(-4, 1,"#f58a1f")

            this.HomeBtnGroup.addMultiple([YesBtn,NoBtn,MenuBack, menuBg, yesBtnTxt, noBtnTxt]);

            for(x in this.HomeBtnGroup.children.entries)
            { 
                this.HomeBtnGroup.children.entries[x].setDepth(this.DepthList.PauseBackDrop);
            }

            YesBtn.on('pointerdown',()=>
            {
                    YesBtn.setEnabled(false);
                    NoBtn.setEnabled(false);
                    this.sound.stopAll();
                    this.scene.start("Intro");
            });

            NoBtn.on('pointerdown',()=>
            {
                    YesBtn.setEnabled(false);
                    NoBtn.setEnabled(false);
                    ////console.log("pressed no");
                    ////console.log(this.HomeBtnGroup);
                    this.PauseBackDrop.setVisible(false);
                    this.DestroyMenu(YesBtn,NoBtn,MenuBack, menuBg, yesBtnTxt, noBtnTxt);
                    Quit.stop();
                    this.PausedToPaintCheck();
            });
        });
        this.HomeButton.PlaySound = false;
        this.HomeButton.setOrigin(.5,.5);
    }

    ClearGroupPass(group)
        {
            ////console.log(group.children);
            ////console.log(group.children.entries[group.children.size-1]);
            group.clear(true,true);
            this.IsPaused = false;
            this.addDelay(100)
            {
                this.MenuButton.setEnabled(true);
            }
        }

    DestroyMenu(Y,N,M, bg, yTxt, nTxt)
        {
            Y.destroy();
            N.destroy();
            M.destroy();
            bg.destroy();
            yTxt.destroy();
            nTxt.destroy();
            this.HomeButton.setEnabled(true);
            this.StartOverButton.setEnabled(true);
            this.BackButton.setEnabled(true)
        }


    //End of Bottom of screen Buttons

    //Tweens
    //Tweens In
    ButtonRollIn(object,TimeTaken,Ease,OffLeft)
        {
            var Rotation;
            var Distance;

            Distance = 6.283 * object.width/2;
            Rotation = Distance/(object.width/2);

            if (OffLeft != true)
            {
                ////console.log("true");
                Distance = Distance * -1;
            }
            else
            {
            Rotation = Rotation * -1;
            }

            //Rotation = Distance/(object.width/2);

            this.addTween(object,TimeTaken,{rotation: Rotation, x: {start:object.x + Distance, to: object.x}},Ease);
        }

    SlidePlateInTween()
        {
            this.addTween(this.Plate,400,{x:{start: this.Plate.x + 800, to: this.Plate.x}},Phaser.Math.Easing.Quadratic.Out);
        }
    
    SetUpTween()
        {
            this.addTween(this.ToolBackground,1,{x: {start:-318,to: -320}}, Phaser.Math.Easing.Quadratic.Out);
            this.addTween(this.Cake, 500, {y: {start: -800, to: -799}, scaleY:1.1}, Phaser.Math.Easing.Quadratic.Out);
        }

    TabMenuTweenIn()
        {
            var x;
            var once = 0;
            ////console.log(this.TabList.length);
            for (x in this.TabList)
            {
                this.addTween(this.TabList[x],500,{x:{start: this.TabList[x].x - 103, to: this.TabList[x].x},delay: x *75},Phaser.Math.Easing.Quadratic.Out,()=>{
                    if(x === "6" && once === 0)
                    {
                        this.FallingInTween();
                        once++;
                    }
                });
            }
        }
    
    ToolBackgroundTweenInStart()
        {
            var x;
            if(this.ToolBackground.x < -215)
            {
                this.addTween(this.ToolBackground,500,{x: -215}, Phaser.Math.Easing.Linear,()=>
                {
                    this.PaintEntry();
                    this.PaintGroup.getChildren().forEach((child)=>
                    {
                        this.addTween(child,500,{x: child.x + 210}, Phaser.Math.Easing.Linear);
                    });
                    this.addTween(this.TabList[0],71.428,{x:0}, Phaser.Math.Easing.Linear);
                    this.SoundCheck("drawer_open_close");
                    this.addTween(this.ToolBackground,500,{x: -5}, Phaser.Math.Easing.Linear,()=>
                    {
                        for (x in this.TabList)
                        {
                            this.TabList[x].setInteractive();
                            this.DoneButton.getAt(0).setInteractive();
                        }
                    });
                });
            }
        }

    FallingInTween()
        {
            this.addTween(this.Cake, 800, {y: this.Plate.y + 40,Delay:170}, Phaser.Math.Easing.Quadratic.In,()=>
            {
                this.ToolBackgroundTweenInStart();
                this.addTween(this.Cake, 100, {scaleY: .9}, Phaser.Math.Easing.Linear);
                this.addTween(this.Cake, 100, {scaleX: 1.1}, Phaser.Math.Easing.Linear,()=>
                {
                    this.addTween(this.Cake, 100, {scaleY: {start: .9, to: 1}}, Phaser.Math.Easing.Linear);
                    this.addTween(this.Cake, 100, {scaleX: {start: 1.1, to: 1}}, Phaser.Math.Easing.Linear,()=>
                    {
                        this.addTween(this.Cake, 100, {scaleY: {start:1, to:.95}}, Phaser.Math.Easing.Linear);
                        this.addTween(this.Cake, 100, {scaleX:{start:1, to:1.05}}, Phaser.Math.Easing.Linear,()=>
                        {
                            this.addTween(this.Cake, 100, {scaleY: {start: .95, to:1}}, Phaser.Math.Easing.Linear);
                            this.addTween(this.Cake, 100, {scaleX: {start:1.05, to:1}}, Phaser.Math.Easing.Linear);
                        });
                    });
                });
            });
        }

    //GamePlay Tweens

    CandleFireIdleTween(ToTween)
        {
                var RandomTimeFlame = Math.floor(Math.random() * 800)+1100;
                var RandomTimeFlameRotate = Math.floor(Math.random() * 800)+1100;
                var fire5 = ToTween;
                var FlameScale = ToTween.scale;

                //this.addTween(ToTween, 100, {y: ToTween.y + 4, yoyo:true, loop: -1, delay: RandomTimeFlame}, Phaser.Math.Easing.Quadratic.In);
                //this.addTween(ToTween, 50, {rotation: {start: ToTween.rotation, from: ToTween.rotation+.09, to: ToTween.rotation-.1}, yoyo:true, loop: -1, delay: RandomTimeFlameRotate}, Phaser.Math.Easing.Quadratic.In);
        
                var Flamen = this.addTween(fire5, 100, {scaleY:FlameScale + .14, yoyo: true},Phaser.Math.Easing.Bounce.Quadratic,()=>{
                    switch(Math.floor(Math.random()*3))
                    {
                        case 0:
                            this.addTween(fire5, 100, {scaleY:FlameScale + .1, yoyo: true,},Phaser.Math.Easing.Bounce.Quadratic,()=>{Flamen.play();});
                                break;
                        case 1:
                            this.addTween(fire5, 60, {scaleY:FlameScale - .1, yoyo: true,},Phaser.Math.Easing.Bounce.Quadratic,()=>{Flamen.play();});
                            break;
                        case 2:
                            this.addTween(fire5, 50, {scaleY:FlameScale + .05, yoyo: true,},Phaser.Math.Easing.Bounce.Quadratic,()=>{Flamen.play();});
                            break;
                    }
                });
        }

    ToolBackgroundTweenIn(group,TabList)
        {
            var x;
            this.addDelay(200,()=>{
                group.getChildren().forEach((child)=>
                {
                    this.addTween(child,200,{x: child.x + 210}, Phaser.Math.Easing.Linear);
                });
                this.addTween(this.TabList[TabList],200,{x:0}, Phaser.Math.Easing.Linear);
                this.addTween(this.ToolBackground,200,{x: -5}, Phaser.Math.Easing.Linear,()=>
                {
                    for(x in this.TabList)
                    {
                        this.DoneButton.getAt(0).setInteractive();
                        this.TabList[x].setInteractive();
                    }
                });
            });
        }

    ToolBackgroundTweenOut(group,TabList,TimeTaken)
        {
            var TimeTween;
            var x;
            var DeleteFlag = false;

            if (isNaN(TimeTaken))
            {

                TimeTween = 200;
            }
            else
            {
 
                TimeTween = TimeTaken;
                DeleteFlag = true;
            }
            group.getChildren().forEach((child)=>
            {
                this.addTween(child,TimeTween,{x: child.x - 210}, Phaser.Math.Easing.Linear);
            });
            //28.57
            this.SoundCheck("drawer_open_close");
            this.addTween(this.TabList[TabList],TimeTween,{x:-30}, Phaser.Math.Easing.Linear);
            this.addTween(this.ToolBackground,TimeTween,{x: -215}, Phaser.Math.Easing.Linear,()=>
            {
                this.StandardExit(group);
                if (DeleteFlag === true)
                {
                    for(x in this.TabList)
                    {
                        this.addTween(this.TabList[x],TimeTween,{scale:0, delay: x * 50}, Phaser.Math.Easing.Linear);
                    }

                    this.addTween(this.ToolBackground,50,{x: -300}, Phaser.Math.Easing.Linear,()=>
                    {
                        this.ToolBackground.destroy();
                    });

                }
            });

            this.DoneButton.getAt(0).disableInteractive();

            for(x in this.TabList)
            {
                this.TabList[x].disableInteractive();
            }
        }

    TweenBackToTray(GameObject)
        {
            var Goal = new Phaser.Math.Vector2();
            var GoalScale;
            if (GameObject.getData('AssetType') != "Icing")
            {
                Goal.x = GameObject.getData('TrayX');
                Goal.y = GameObject.getData('TrayY');
                GoalScale = GameObject.getData('TrayScale');
                //console.log(Goal);

                this.addTween(GameObject,400,{x:Goal.x, y:Goal.y, scale: GoalScale, alpha: 0},Phaser.Math.Easing.Linear,()=>
                {
                    GameObject.destroy();
                });
            }
            else
            {
                switch (GameObject.frame.name)
                {
                    case "Decorations/Icing/Icing_1.png": 
                        Goal.x = 220;
                        Goal.y = 91.66666666666666;
                        break;
                    case "Decorations/Icing/Icing_2.png": 
                        Goal.x = 220;
                        Goal.y = 211;
                        break;
                    case "Decorations/Icing/Icing_3.png": 
                        Goal.x = 220;
                        Goal.y = 330.3333333333333;
                        break;
                    case "Decorations/Icing/Icing_4.png": 
                        Goal.x = 220;
                        Goal.y = 449.66666666666663;
                        break;
                    case "Decorations/Icing/Icing_5.png": 
                        Goal.x = 220;
                        Goal.y = 569;
                        break;
                    case "Decorations/Icing/Icing_6.png": 
                        Goal.x = 220;
                        Goal.y = 688.3333333333333;
                        break;
                    default:
                        break;
                }
                this.addTween(GameObject,400,{x:Goal.x, y:Goal.y, alpha: 0},Phaser.Math.Easing.Linear,()=>
                {
                    GameObject.destroy();
                });
            }
        }

    //End of Tweens

    //Util

    SoundCheck(sound)
        {
            if (gameData.gameMuted != true)
            {
                this.playSound(sound);
            }
        }

    AddRenderTextureCheck() //Used to check that a empty render texture is not created if one is active
        {
            if (this.NeedNewRender === true)
            {
                if (this.DrawOn.length != 0){
                    this.CakeGroup.add(this.DrawOn[this.DrawOn.length-1]);
                }
                
                this.DrawOn.push(this.add.renderTexture(this.Cake.getLeftCenter().x, this.Cake.getTopCenter().y, 484, 390));
                this.DrawOn[this.DrawOn.length-1].setDepth(this.DepthList.DrawTool);
                this.DrawOn[this.DrawOn.length-1].setData('DrawingsOn',[]);
                //console.log(this.DrawOn[this.DrawOn.length-1].getData('DrawingsOn',[]));
                this.DrawOn[this.DrawOn.length-1].setMask(this.CakeMask);
                this.NeedNewRender = false;
            }

            //if(this.BackLog.length === 0)
            //{
            //    //console.log("zero add");
            //    this.BackLog[this.ObjectCount] = (this.add.renderTexture(315, 0, 1024, 692));
            //    this.DrawOn[0] = this.BackLog[this.ObjectCount];
            //    this.ObjectCount++;    
            //}
//
            //else if (this.BackLog.length != 0);
            //{
            //    if (this.BackLog[this.ObjectCount-1].Type != "RenderTexture")
            //    {
            //        this.BackLog[this.ObjectCount] = (this.add.renderTexture(315, 0, 1024, 692));
            //        this.DrawOn[0] = this.BackLog[this.ObjectCount];
            //        this.ObjectCount++;
            //    }
            //}
        }

    DoneAction()
        {
            if(this.IsPaused != true)
            {
                this.SoundCheck("button_menu_click");
                this.DoneButttonLeaveCheck();
                this.CircleRollOut(100,this.HomeButton,500,Phaser.Math.Easing.Quadratic.InOut);
                this.CircleRollOut(100,this.BackButton,500,Phaser.Math.Easing.Quadratic.InOut);
                this.CircleRollOut(100,this.StartOverButton,500,Phaser.Math.Easing.Quadratic.InOut);

                var SecondBackGround;
                var OverImage;
                var FlameSend = [];
                var x = 0;
                var FireName;

                this.FireGroup.getChildren().forEach((Child)=>
                {
                    this.addTween(Child, 100, {scale: 0, alpha: 0});
                });

                this.CandlesToSend.getChildren().forEach((Child)=>
                {
                    FireName = Child.frame.name.split("_");
                    FlameSend[x] = {Xcord: Child.getTopCenter().x,Ycord: Child.getTopCenter().y,Name: FireName[0] + "_Fire_" + FireName[1]};
                    //console.log(FlameSend);
                    
                    x++;
                });


                this.addTween(this.DoneButton,200,{y: this.DoneButton.y + 100});
                if (this.SoundOnButton.visible === false)
                {
                    this.CircleRollOut(100,this.SoundOffButton,500,Phaser.Math.Easing.Quadratic.InOut);
                }
                else 
                {
                    this.CircleRollOut(100,this.SoundOnButton,500,Phaser.Math.Easing.Quadratic.InOut);
                }
                //console.log("Moving things");
                //console.log(this.CakeGroup);
                this.DrawOn.push(this.add.renderTexture(0, 0, 1094, 768));
                this.DrawOn[this.DrawOn.length-1].visible = false;
                this.DrawOn[this.DrawOn.length-1].setDepth(this.DepthList.Render);
                this.addDelay(900,()=>
                {
                    //SecondBackGround = this.addImage(this.mid.x, this.mid.y, "Background.png");
                    //this.DrawOn[this.DrawOn.length-1].draw(this.CakeGroup);
                    //MaskedRender.draw(this.MaskAndPaint);
                    //MaskedRender.setMask(this.CakeMask);
                    //MaskedRender.setDepth(6);

                    //MaskedRender.visible = false;
                    
                    //console.log(this.game.renderer.snapshot);
                    //console.log(this.events.preupdate);
                    //this.events.once('postupdate',()=>{
                        ////console.log("first");
                        this.BackGround.setVisible(false);
                    this.game.renderer.snapshotArea(314,0,710,768,(image)=>
                    {
                        //this.load.image('snap',image.src);

                        ////console.log(Phaser.utils.Base64ToArrayBuffer(image.src));
                        if (this.textures.exists('snap'))
                        {
                            this.textures.remove('snap');
                            this.textures.removeKey('snap');
                        }
                        this.textures.addBase64('snap',image.src);
                        this.textures.once('addtexture',()=>
                        {
                            OverImage = this.add.image(314,0,'snap');
                            OverImage.setOrigin(0,0);
                            OverImage.setDepth(this.DepthList.OverImage);
                            SecondBackGround = this.addImage(this.mid.x, this.mid.y, "Background.png");
                            SecondBackGround.setDepth(this.DepthList.Snapshot);
                            this.addTween(OverImage,700,{x:OverImage.x+900},Phaser.Math.Easing.Quadratic.InOut,()=>
                            {
                                this.scene.start("EndCake",{Candle: FlameSend});
                            });
                            ////console.log("first");
                            //this.BackGround.setVisible(true);
                            //this.scene.start("EndCake",{render: image.src});
                        });
                    });

                    //});
                    /*
                    this.events.once('preupdate',()=>{
                        //console.log("Second");
                        this.BackGround.setVisible(true);
                    });
                    */
                    
                    //MaskedRender.draw(this.game.renderer.snapshot);
                    //MaskedRender.y += 900;
                    //this.DrawOn[this.DrawOn.length-1].setMask(this.CakeMask);
                    //this.DrawOn[this.DrawOn.length-1].visible = true;
                    //this.SoundCheck("cake_slide_in");
                    ////console.log(this.CakeMask);
                    /*
                    this.addTween(this.CakeMask.geometryMask,700,{x:this.CakeMask.geometryMask.x + 900},Phaser.Math.Easing.Quadratic.InOut);
                    this.addTween(this.DrawOn[this.DrawOn.length-1],700,{x:this.DrawOn[this.DrawOn.length-1].x+900},Phaser.Math.Easing.Quadratic.InOut,()=>
                    {
                        SecondBackGround.setDepth(6);
                        this.DrawOn[this.DrawOn.length-1].x = 0;
                        this.DrawOn[this.DrawOn.length-1].ignoreDestroy= true;
                        this.scene.start("EndCake",{render: this.DrawOn[this.DrawOn.length-1]});
                    });
                    */
                    
                });
            }
        }

    CreateBackLogEntry(Operation,GameObject,PreviousObject,AssetType)
        {
            var Command = 
            {
                Type: Operation,
                AssetType: AssetType,
                Id: this.ObjectCount,
                Ref: GameObject,
                Previous: {x:PreviousObject.x,y:PreviousObject.y},
                PrevID: "",
                PrevAssetType: ""
            };

            var MoveData;

            this.BackLog.push(Command);
            //console.log(this.BackLog);
            if (Operation != "Move")
            {
                GameObject.setData('AssetType',AssetType);
            }
            switch (Operation)
            {
                case "Move":
                    MoveData = GameObject.getData('MoveLog');
                    MoveData.push(this.ObjectCount);
                    GameObject.setData('MoveLog',MoveData);
                    //console.log("Move Command Switch");
                    break;

                case "Place":
                    GameObject.setData('BackID',this.ObjectCount);
                    GameObject.setData('MoveLog',[]);
                    this.NeedNewRender = true;
                    break;

                case "Draw":

                    break;

                case "Replace":
                    Command.PrevID = PreviousObject.getData('BackID');
                    //console.log(Command.PrevID);
                    Command.PrevAssetType = PreviousObject.getData('AssetType');
                    this.BackLog[this.BackLog.length-1].Ref.setData({BackID: this.ObjectCount,AssetType: "Icing"});
                    this.NeedNewRender = true;
                    break;

                default:
                    break;
            }
            this.ObjectCount++;
        }

    CreateDrawBackLog(RenderTexture,Drawing)
        {
            var Command = 
            {
                Type: "Draw",
                Id: this.ObjectCount,
                RenderTexture: RenderTexture,
                Drawing: Drawing
            };


            this.BackLog.push(Command);
            //console.log(this.BackLog);
            this.ObjectCount++;
        }

    OverButtonCheck(GameObject)
        {

            if(this.BoundsOverlap(GameObject,this.StartOverButton)) return true;
            else if(this.BoundsOverlap(GameObject,this.HomeButton)) return true;
            else if(this.BoundsOverlap(GameObject,this.BackButton)) return true;
            else if(this.BoundsOverlap(GameObject,this.SoundOnButton)) return true;
            else if(this.BoundsOverlap(GameObject,this.SoundOffButton)) return true;
            else if(this.BoundsOverlap(GameObject,this.DoneButton.getAt(0))) return true;
            else
            {
                return false;
            }
        }
    
    IcingRemoveFromBack(Icing)
        {
            var x;

            for (x = this.BackLog.length; x > 0; x--)
            {
                if (this.BackLog[(x-1)].Id === Icing.getData('BackID'))
                {
                    //console.log(this.BackLog);
                    this.BackLog.splice((x-1),1);
                    //console.log("Splice based on move");
                    Icing.destroy();
                    //console.log(this.BackLog);
                    this.CurrentIcing = "null";
                }
            }
        }

    MoveBackLogClear(GameObject)
        {
            var BackLogDelete = [];
            var MoveData;
            var i;
            var x;
            var Increm;

            for(x=0; x < this.BackLog.length;x++)
            {
                if(this.BackLog[x].Id === GameObject.getData('BackID'))
                {
                    if (this.BackLog[x].Type === "Replace")
                    {
                        for(i=0; i < this.BackLog.length;i++)
                        {
                            if(this.BackLog[i].Id === this.BackLog[x].PrevID)
                            {
                                BackLogDelete.push(i);
                                i = this.BackLog.length;
                            }
                        }
                    }

                    MoveData = this.BackLog[x].Ref.getData('MoveLog');
                    //console.log(MoveData);
                    for(Increm in MoveData)
                    {
                        for(i=0; i < this.BackLog.length;i++)
                        {
                            if(this.BackLog[i].Id === MoveData[Increm])
                            {
                                BackLogDelete.push(i);
                            }
                        }
                    }
                    BackLogDelete.push(x);

                    this.TweenBackToTray(GameObject);
                    //console.log(this.BackLog);
                    x = this.BackLog.length;
                }
            }
            BackLogDelete.sort(function(a, b){return b-a});
            //console.log(BackLogDelete);
            for (Increm in BackLogDelete)
            {

                this.BackLog.splice(BackLogDelete[Increm],1);
            }
            //console.log(this.BackLog);
        }

    PausedToPaintCheck()
        {
            this.MouseUpCheck = true;
        }

    CircleRollOut(Distance,Object,TimeTaken,Ease)
        {
            var Rotation;

            Rotation = Distance/(Object.width/2);
            this.addTween(Object,TimeTaken,{rotation: Rotation, x: Object.x + Distance},Ease);
        }

    update()
        {
            if (this.MoveThis != "null")
            {
                this.MoveThis.x = this.input.activePointer.x;
                this.MoveThis.y = this.input.activePointer.y;
            }
        }
}